import AcceptedOrderDetailFooterActionButtons from '@/components/OrdersModule/OrderDetail/Footer/AcceptedOrderDetailFooter/AcceptedOrderDetailFooterActionButtons'
import PostponeOrderTimeSelector from '@/components/OrdersModule/OrderDetail/Footer/AcceptedOrderDetailFooter/PostponeOrderTimeSelector/PostponeOrderTimeSelector'
import { minimalPostponeOrderTimeInMinutes } from '@/constants/order-flow-action-time-values'
import { postponingEnabled } from '@/constants/orders'
import OrderHistoryCollapsible from '@/features/orders/components/OrderDetail/Footer/OrderHistoryCollapsible'
import ContextMenu from '@/features/orders/components/OrderDetail/parts/Footer/ContextMenu'
import FooterLayout from '@/features/orders/components/OrderDetail/parts/Footer/FooterLayout'
import { useAppSelector } from '@/hooks/redux'
import { useIntervaledState } from '@/hooks/useIntervalState'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { calculatePostponedUntil } from '@/utils/postponeOrderTime'
import dayjs from 'dayjs'
import { FC, useCallback, useEffect, useState } from 'react'

interface AcceptedOrderDetailFooterProps {
    orderUuid: string
}

const AcceptedOrderDetailFooter: FC<AcceptedOrderDetailFooterProps> = ({ orderUuid }) => {
    const order = useAppSelector(ordersSelectors.orderByUuid(orderUuid))

    const [isPostponeOrderMode, setIsPostponeOrderMode] = useState(false)

    const postponeDisabled = useIntervaledState(
        useCallback(() => {
            if (!order) {
                return true
            }

            const postponementTime = dayjs.duration({
                minutes: minimalPostponeOrderTimeInMinutes,
            })

            return calculatePostponedUntil(order, postponementTime).isBefore(dayjs())
        }, [order]),
        60000
    )

    useEffect(() => {
        if (!postponeDisabled) return

        turnOffPostponeOrderMode()
    }, [postponeDisabled])

    if (!order) {
        return null
    }

    const turnOffPostponeOrderMode = () => {
        setIsPostponeOrderMode(false)
    }

    const turnOnPostponeOrderMode = () => {
        setIsPostponeOrderMode(true)
    }

    return (
        <>
            {!isPostponeOrderMode ? (
                <FooterLayout
                    TopContent={<OrderHistoryCollapsible activityLogs={order.activityLogs} />}
                    ContextMenu={<ContextMenu orderUuid={orderUuid} />}
                    suppressContextMenuPlaceholderInCompact={postponingEnabled}
                >
                    <AcceptedOrderDetailFooterActionButtons
                        orderUuid={orderUuid}
                        postponeDisabled={postponeDisabled}
                        onPostponeButton={turnOnPostponeOrderMode}
                    />
                </FooterLayout>
            ) : (
                <FooterLayout
                    TopContent={<OrderHistoryCollapsible activityLogs={order.activityLogs} />}
                >
                    <PostponeOrderTimeSelector
                        orderUuid={orderUuid}
                        onBackButton={turnOffPostponeOrderMode}
                    />
                </FooterLayout>
            )}
        </>
    )
}

export default AcceptedOrderDetailFooter
